<template>
<span class="badge-small ml-10"
  :class="getColorClass" v-if="countDetails[1]">
  {{countDetails[0]}} / {{countDetails[1]}}
</span>
</template>
<script>
export default {
  props: ['countDetails'],
  computed: {
    getColorClass() {
      if (this.countDetails[0] / this.countDetails[1] === 1) {
        return 'badge-green';
      } else if (this.countDetails[0] / this.countDetails[1] >= 0.75) {
        return 'badge-yellow';
      }
      return 'badge-red';
    },
  },
};
</script>
